'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { captureAdParams, captureLandingMeta } from '@/utilities/adTracking'

export function AdParamsCapture() {
  const pathname = usePathname()

  useEffect(() => {
    captureAdParams()
    // First-touch only — captureLandingMeta() no-ops once already set, so
    // this is safe to call on every route change without re-arming.
    captureLandingMeta(pathname)
  }, [pathname])

  return null
}
